import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Nav, Tab } from "react-bootstrap";
import styled from "styled-components";
import getUnixTime from "date-fns/getUnixTime";
import { FormProvider, useForm } from "react-hook-form";
import axios from "axios";

import { Card, CardBody } from "@/shared/components/Card";
import FormHeader from "../../../shared/components/form/FormHeader";
import { NavItem, NavLink, TabsWrap } from "@/shared/components/Tabs";
import { FormContainer } from "../../../shared/components/form/FormElements";
import { scrollbarStyles } from "../../../utils/palette";
import { addMsg } from "../../../features/snackbar/snackbarSlice";
import {
  getToken,
  getVehicles,
  post,
  postApi,
  urlConfig,
} from "../../../api/getUser";
import InfoPopup from "../../../shared/components/InfoPopup";
import { isObjEmpty, uploadDocsToS3 } from "../../../shared/helpers";
import EquipmentDetailsForm from "./EquipmentDetailsForm";
import UsersAssignedForm from "../Vehicles/UsersAssignedForm";
import LinkedVehicleTab from "./LinkedVehicleTab";
import { auth } from "../../../api/firebase";
import { updateVehiclesList } from "../../../features/vehicles/vehiclesSlice";

const EquipmentForm = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const routeData = location?.state?.data;
  const rowData = routeData?.rowData;
  const screen = location?.state?.screen;
  const type = location?.state?.type;

  const { orgId, userId } = useSelector((state) => state.user);
  //const { distance } = useSelector((state) => state.units);

  const methods = useForm();
  const { watch } = methods;
  const { errors } = methods.formState;

  const equipmentName = watch("equipmentName");
  const licenseNo = watch("licenseNo");
  const equipmentType = watch("equipmentType");
  const vin = watch("vin");
  const status = watch("status");
  const make = watch("make");
  const model = watch("model");
  const year = watch("year");
  const group = watch("group");
  //const fuelType = watch("fuelType");
  const primaryMeter = watch("primaryMeter");
  //const startingOdo = watch("startingOdo");
  const purchasePrice = watch("purchasePrice");
  const outOfService = watch("outOfService");
  const linkedVehicle = watch("linkedVehicle");

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  //For showing info popup during save
  const [addVehicleFailedData, setAddVehicleFailedData] = useState({
    message: "",
    icon: { className: "fi fi-rr-triangle-warning", color: "red" },
  });
  const [addVehicleFailed, setAddVehicleFailed] = useState(false);

  //State for users assigned
  const [usersAssigned, setUsersAssigned] = useState([]);
  //State to check if users assigned has been changed
  const [userAssignedUpdated, setUserAssignedUpdated] = useState(false);

  const [activeKey, setActiveKey] = useState("1");

  const [vehiclePhoto, setVehiclePhoto] = useState("");

  const onSubmit = async () => {
    try {
      const vehicleId =
        type === "edit" ? rowData.veh_id : `${orgId}_${Date.now()}`;

      setSaveBtnLoading(true);

      //Check if vehicle already exists
      const token = await getToken(); //sessionStorage.getItem("token");
      const email = auth?.currentUser?.email;
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const uniqueVehicleApiRes = await axios.post(
        urlConfig.commonNew,
        {
          email,
          querystring: "check_vehicle_exist",
          operation: type === "edit" ? "update" : "create",
          veh_id: vehicleId,
          name: equipmentName ? equipmentName : "",
          vin_no: vin ? vin : "",
          license_no: licenseNo ? licenseNo : "",
          asset_type: 1,
        },
        config
      );

      const resData = uniqueVehicleApiRes.data;
      // if (resData.success) {
      const { data } = resData;
      let errMsg = "";
      if (data == 1 || data == 2 || data == 3 || data == 4) {
        if (data == 1) {
          errMsg = t("equipment_limit_reached_err");
        } else if (data == 2) {
          errMsg = t("duplicate_entry_veh_name_err");
        } else if (data == 3) {
          errMsg = t("duplicate_entry_veh_vin_err");
        } else if (data == 4) {
          errMsg = t("duplicate_entry_veh_license_err");
        }
        setAddVehicleFailedData((prev) => ({
          ...prev,
          message: errMsg,
        }));
        setAddVehicleFailed(true);
        setSaveBtnLoading(false);
        return;
      }
      // }

      let imagesToS3 = [];

      //const distanceFactor = getDistanceFactor(primaryMeter?.value, distance);
      //let startingodoConverted = startingOdo ? startingOdo * distanceFactor : 0;
      const apiData = {
        vehicle_name: equipmentName,
        make: make ? make : "",
        model: model ? model : "",
        veh_type: equipmentType ? equipmentType?.value : "",
        veh_active: status ? 1 : 0,
        secondary_status: outOfService ? 1 : 0,
        year: year ? year : 0,
        license_no: licenseNo ? licenseNo : "",
        vin_no: vin ? vin : "",
        veh_img: vehiclePhoto ? vehiclePhoto.imgName : "",
        starting_odo: 0,
        primary_meter: primaryMeter ? primaryMeter?.value : "",
        custom_specs: "",
        width: "",
        length: "",
        height: "",
        weight: "",
        cargo_value: "",
        max_payload: "",
        front_tyre_info: "",
        front_tyre_psi: "",
        rear_tyre_info: "",
        rear_tyre_psi: "",
        fuel_type: "",
        additional_documents: "",
        fuel_quality: "",
        oil: "",
        oil_capacity: "",
        fuel_tank_capacity: "",
        action: type === "edit" ? 2 : 1,
        operation: type === "edit" ? "update" : "create",
        sync_version: "v2",
        veh_id: vehicleId,
        group_id: group ? group?.group_id : "",
        purchase_price: purchasePrice ? purchasePrice : 0,
        provider_type_1: 0,
        asset_type: 1,
        linked_veh: linkedVehicle ? linkedVehicle?.veh_id : "",
      };

      //Add override values if override odo has changed
      //   if (type === "edit" && roleId === 1 && isOdoOverridden.current) {
      //     if (+currentOdo !== +rowData?.odo) {
      //       apiData.odo_override = +currentOdo;
      //       apiData.odo_override_date = getUnixTime(new Date());
      //     }
      //   }

      const userssAssignedIds = usersAssigned.map((u) => u.user_id);
      const userApiData = {
        querystring: "vehicle_operator_update",
        operator_id: userssAssignedIds,
        veh_id: vehicleId,
        vehicle_operation: "update",
      };

      const response = await post("vehicle", apiData);
      if (userAssignedUpdated) {
        const vehResponse = await postApi(userApiData, "commonNew");
      }

      if (!response?.success) {
        const { code } = response;
        if (code == 1) {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("equipment_limit_reached_err"),
          }));
        } else if (code == 2) {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("duplicate_entry_veh_name_err"),
          }));
        } else if (code == 3) {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("duplicate_entry_veh_vin_err"),
          }));
        } else if (code == 4) {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("duplicate_entry_veh_license_err"),
          }));
        } else if (code == 5) {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("duplicate_entry_veh_err"),
          }));
        } else {
          setAddVehicleFailedData((prev) => ({
            ...prev,
            message: t("form_err_msg"),
          }));
        }
        setSaveBtnLoading(false);
        setAddVehicleFailed(true);
        return;
      }
      if (response?.success) {
        //Update link history
        const isEdit = type === "edit";
        const prevLinkedVeh = rowData?.linked_veh || null;
        const newLinkedVeh = linkedVehicle?.veh_id || null;

        const isNewLinkChanging =
          linkedVehicle && (!isEdit || prevLinkedVeh !== newLinkedVeh);
        const isUnlinking = !linkedVehicle && prevLinkedVeh;

        //Only update link history if status is active since status inactive case is handled in vehicle update api
        const shouldAddLinkHistory =
          (isNewLinkChanging || isUnlinking) && status;

        if (shouldAddLinkHistory) {
          const linkApiData = {
            se_veh_id: vehicleId,
            veh_id: newLinkedVeh,
            operation: "update_link_history",
            prev_veh_id:
              isEdit && prevLinkedVeh && prevLinkedVeh !== newLinkedVeh
                ? prevLinkedVeh
                : null,
          };

          await post("vehicle", linkApiData);
        }

        const snackbarMsg =
          type === "edit"
            ? t("record_edited_msg", { recordName: t("equipment") })
            : t("record_added_msg", { recordName: t("equipment") });

        if (vehiclePhoto && vehiclePhoto.file) {
          imagesToS3.push({
            file: vehiclePhoto.file,
            key: `image_data/org_${orgId}/vehicle_${vehicleId}/${vehiclePhoto.imgName}`,
          });
        }

        //Update vehicles list in redux
        const updatedVehiclesList = await getVehicles();
        dispatch(updateVehiclesList(updatedVehiclesList));

        if (imagesToS3?.length > 0) {
          const docsUploaded = await uploadDocsToS3(imagesToS3);
          if (docsUploaded) {
            dispatch(addMsg(snackbarMsg));
            setSaveBtnLoading(false);
            history.push("/assets/equipment", {
              fromCancel: false,
            });
          }
        } else {
          dispatch(addMsg(snackbarMsg));
          setSaveBtnLoading(false);
          history.push("/assets/equipment", {
            fromCancel: false,
          });
        }
      }
    } catch (e) {
      console.log(e);
      setAddVehicleFailedData((prev) => ({
        ...prev,
        message: t("form_err_msg"),
      }));
      setSaveBtnLoading(false);
      setAddVehicleFailed(true);
      return;
    }
  };

  return (
    <FormProvider {...methods}>
      {addVehicleFailed && (
        <InfoPopup
          message={addVehicleFailedData.message}
          icon={addVehicleFailedData.icon}
          showPopup={addVehicleFailed}
          setShowPopup={setAddVehicleFailed}
        />
      )}
      {/* {showCurrentOdoWarnPopup && (
        <ActionPopup
          showPopup={showCurrentOdoWarnPopup}
          setShowPopup={setShowCurrentOdoWarnPopup}
          handleNo={handleCancelSave}
          handleYes={handleSaveVehicle}
          message={t("you_are_overriding_current_odo_warn_msg")}
          yesBtnLoading={saveBtnLoading}
          yesBtnText={t("confirm")}
          noBtnText={t("cancel")}
        />
      )} */}
      <FormContainer onSubmit={methods.handleSubmit(onSubmit)}>
        <FormHeader
          handleCancel={() =>
            history.push("/assets/equipment", {
              fromCancel: true,
            })
          }
          //disableSave={!vehicle}
          isSaveLoading={saveBtnLoading}
          title={type === "edit" ? t("edit_equipment") : t("add_equipment")}
          //handleCancel={handleCancel}
        />
        <Container>
          <Row>
            <Col xs={12} md={12} lg={12} xl={12}>
              <Card>
                <CardBody
                  style={{
                    padding: 0,
                    //height: `${window.innerHeight - 150}px`,
                    //overflow: "auto",
                  }}
                >
                  <TabsWrap>
                    <Tabs
                      rowData={rowData}
                      type={type}
                      errors={errors}
                      usersAssigned={usersAssigned}
                      setUsersAssigned={setUsersAssigned}
                      userAssignedUpdated={userAssignedUpdated}
                      setUserAssignedUpdated={setUserAssignedUpdated}
                      activeKey={activeKey}
                      setActiveKey={setActiveKey}
                      vehiclePhoto={vehiclePhoto}
                      setVehiclePhoto={setVehiclePhoto}
                    />
                  </TabsWrap>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </FormContainer>
    </FormProvider>
  );
};

export default EquipmentForm;

const Tabs = ({
  rowData,
  type,
  errors,
  usersAssigned,
  setUsersAssigned,
  userAssignedUpdated,
  setUserAssignedUpdated,
  activeKey,
  setActiveKey,
  vehiclePhoto,
  setVehiclePhoto,
  //isOdoOverridden,
  //currentOdoWarnMsg,
  //setCurrentOdoWarnMsg,
}) => {
  const { t } = useTranslation("common");

  return (
    <Tab.Container activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
      <TabsWrap>
        <Nav className="nav-tabs">
          <NavItem id="equipment-details-tab" $active={activeKey == "1"}>
            <NavLink eventKey="1" name="equipment-details-link">
              {t("equipment_details")}{" "}
              {!isObjEmpty(errors) && (
                <i
                  className="fi fi-rr-triangle-warning"
                  style={{
                    color: "red",
                    position: "relative",
                    top: "2px",
                  }}
                ></i>
              )}
            </NavLink>
          </NavItem>

          <NavItem id="users-assigned-tab" $active={activeKey == "2"}>
            <NavLink eventKey="2" id={"users-assigned-link"}>
              {usersAssigned?.length > 0
                ? t("count_users_assigned", {
                    count: usersAssigned?.length,
                  })
                : t("user_assignment")}
            </NavLink>
          </NavItem>

          <NavItem id="linked-vehicle-tab" $active={activeKey == "3"}>
            <NavLink eventKey="3" id={"linked-vehicle-link"}>
              {t("linked_vehicle")}
            </NavLink>
          </NavItem>
        </Nav>

        <Tab.Content>
          <TabPane eventKey="1">
            <EquipmentDetailsForm
              rowData={rowData}
              type={type}
              setUsersAssigned={setUsersAssigned}
              userAssignedUpdated={userAssignedUpdated}
              setUserAssignedUpdated={setUserAssignedUpdated}
              vehiclePhoto={vehiclePhoto}
              setVehiclePhoto={setVehiclePhoto}
              setActiveKey={setActiveKey}
            />
          </TabPane>

          <TabPane eventKey="2">
            <UsersAssignedForm
              usersAssigned={usersAssigned}
              setUsersAssigned={setUsersAssigned}
              userAssignedUpdated={userAssignedUpdated}
              setUserAssignedUpdated={setUserAssignedUpdated}
              type={type}
              rowData={rowData}
              assetType={"equipment"}
            />
          </TabPane>

          <TabPane eventKey="3">
            <LinkedVehicleTab rowData={rowData} type={type} />
          </TabPane>
        </Tab.Content>
      </TabsWrap>
    </Tab.Container>
  );
};

export const TabPane = styled(Tab.Pane)`
  ${scrollbarStyles};
  height: calc(var(--window-height, 100vh) - 180px);
  overflow: auto;
  //padding: 1rem;
`;
